import { css } from "@emotion/css";
import { Spacing } from "@snapchat/snap-design-system";

export const sectionSpacing = css`
    margin-bottom: ${Spacing.LG}px;
`;

export const lensDetailsContainer = css`
    flex: 1;
`;
